import Player from "../Player";
import ICustomFormSettings from "../../ICustomFormSettings";
import AudioPlayer, {AudioPlayerConfig} from "../../shared/components/MediaPlayer/AudioPlayer";


export default class PlayerAudio extends Player {

    protected readonly player;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        this.player = new AudioPlayer(
            this.link,
            <AudioPlayerConfig>this.config,
            () => {
                this.fulfilledField.setVariable(1);
                this.player.enableSeeker();
            },
        );
    }

}